import Component from '../core/Component'

export const STATES = {
    CHECKED: 'is-checked'
}

export default class CheckboxCheck extends Component {
    constructor(element) {
        super(element)

        this.ref = {
            checkbox: null
        }
    }

    prepare() {
        this.ref.checkbox.addEventListener('change', this.handleClick)
        this.handleClick()
    }

    destroy() {
        this.ref.checkbox.removeEventListener('change', this.handleClick)
    }

    handleClick = () => {
        if (this.ref.checkbox.checked) {
            this.element.classList.add(STATES.CHECKED)
        } else {
            this.element.classList.remove(STATES.CHECKED)
        }
    }
}



// WEBPACK FOOTER //
// ./components/CheckboxCheck.js